/**
 * PendingBadge (R50) — small numeric "things to review" badge, reused by the
 * admin module cards and the sidebar. Renders nothing when count <= 0, so
 * callers can drop it in unconditionally. Counts over `max` show as `max+`.
 */
interface PendingBadgeProps {
	count: number;
	/** Cap before showing `{max}+`. Default 99. */
	max?: number;
	className?: string;
	'aria-label'?: string;
}

export function PendingBadge({ count, max = 99, className = '', ...rest }: PendingBadgeProps) {
	if (!count || count <= 0) return null;
	const label = count > max ? `${max}+` : String(count);

	return (
		<span
			className={`inline-flex min-w-[18px] items-center justify-center rounded-full border border-red-200 bg-red-50 px-1.5 text-[11px] font-semibold leading-[18px] text-red-700 ${className}`}
			aria-label={rest['aria-label'] ?? `${count} pendientes`}
		>
			{label}
		</span>
	);
}
